import { cn } from '@/lib/cn';
import { useFormatMoney } from '@/hooks/useFormatMoney';

type Props = {
  value: string | null | undefined;
  fallback?: string;
  className?: string;
};

export function MoneyDisplay({ value, fallback = '—', className }: Props) {
  const fmt = useFormatMoney();
  return <span className={cn('tabular-nums', className)}>{fmt(value, fallback)}</span>;
}
